import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";

const StatusList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Priority",
      accessorKey: "priority",
      cell: NACell,
    },
    {
      header: "Color",
      accessorKey: "color",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={`h-4 w-16`} style={{background: getValue()}}>
          </div>
        )
      },
    },
    {
      header: "Allow RTV Order",
      accessorKey: "is_allow_to_create_rtv",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue()?"True":"False"}
          </>
        )
      },
    },
    {
      header: "Is Final State",
      accessorKey: "is_final_state",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue()?"True":"False"}
          </>
        )
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.STATUS}
      queryKey={"status"}
      columns={defaultColumns}
      addNewPagePath={"/create-status"}
      tableName={"Status"}
    />
  );
};

export default StatusList;
